export default function getResource(label, vars = []) {
    const resources = {
        title: 'Enregistré pour plus tard',
        moveToBasket: 'Déplacer dans le panier',
        moved: 'L’article a été déplacé',
        remove: 'Retirer',
        noItems: 'Aucun article enregistré pour plus tard',
        movedToBasket: `a été déplacé dans votre ${vars[0]}`,
        gotIt: 'Compris',
        undo: 'Annuler',
        deliveryMethodStandard: 'Commande d’articles à expédier',
        deliveryMethodBOPIS: 'Commande « Achetez en ligne, ramassez en magasin »',
        deliveryMethodSameday: 'Commande de livraison le jour même',
        itemShip: 'Désolé, cet article n’est pas offert dans votre pays.'
    };

    return resources[label];
}
